/**
 * /admin/videos — the video library. Every video a coach page or a course can
 * show is added here once, then chosen by placements and course weeks. Rows
 * never show where a video is hosted; "Preview" plays it in place. Search
 * matches titles; the filters group videos by where they are shown, the only
 * grouping videos have.
 *
 * Aliases: video library admin, admin videos, wistia videos
 */

import { createFileRoute } from "@tanstack/react-router";

import { requirePermission } from "~/lib/functions/admin-access";
import { videosQueryOptions } from "~/lib/functions/admin-learning";

import { VideoLibrary } from "./-components/video-library";

export const Route = createFileRoute("/admin/videos/")({
  staticData: { title: "Videos" },
  beforeLoad: ({ context }) =>
    requirePermission(context.adminPermissions, "videos:read"),
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(videosQueryOptions());
  },
  component: VideoLibraryPage,
});

function VideoLibraryPage() {
  const { adminPermissions } = Route.useRouteContext();
  return <VideoLibrary permissions={adminPermissions} />;
}
